module.exports = __webpack_public_path__ + "static/sprologo.e612e808.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sprologo.png
// module id = 1380
// module chunks = 129519670211406 199180123508537